// test1607
(1607 && 0);
